/**
 * Tabs of the Andys landing (#1108). Not in AndysBuyRentLease.jsx: the
 * container needs the opening tab too — it's the `tab` of a close event that
 * comes before any tap (#1482) — and a .jsx file exports only components.
 */

// Buy is the centre tab (routing hub default). Order: Rent · Buy · Lease.
export const ANDYS_TABS = [
  { value: 'rent', label: 'Rent' },
  { value: 'buy', label: 'Buy' },
  { value: 'lease', label: 'Lease' },
];

/** The tab the landing opens on. */
export const ANDYS_DEFAULT_TAB = 'buy';
